import { ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

import { EVENTS } from '../interfaces';

class ImageGallerySlideshowModalController {

	public backgroundColor:string="#000000"; 	
	public contentModule;
	public contentModuleImage;
	public fade = true;
	public image;
	public imageSelector = '#GalleryModalCenter .slick-active img';
	public images;
	public goTo;
	public loading = true;
	public originalWidth;
	public originalHeight;

	// meanings behind these bools is backwards to the name.
	// when hide... === true, then it's showing
	public hideImageCreditLine = true; 
	public hideImageNote = true; 
	public hideBookCreditLine = true;
	public hideLessonCaption = true;
	public hideLessonCreditLine = true;
	public hidePortfolioCaption = true;
	
	//property to hide footer for single image
	public hideFooter;
	
	public currentMarginLeft = 0;
	public currentMarginTop = 0;
	
	public showToolTip = true;
	public slickInitialized = false;
	public speed;
	public speedOptions = [
		{
			name: '5 sec',
			value: 5000
		},	
		{
			name: '10 sec',
			value: 10000
		},	
		{
			name: '15 sec',
			value: 15000
		},	
		{
			name: '20 sec',
			value: 20000
		},
		{
			name: '30 sec', 
			value: 30000
		}
	]
	
	public transitionSpeed = 300;
	
	public playing = false;
	
	public zoomValue; 
	public zoomOptions = [
		{
			name:"25%",
			value:.25
		},
		{
			name:"50%",
			value:.50
		},
		{
			name:"75%",
			value:.75
		},
		{
			name:"100%",
			value:1
		},
		{
			name:"125%",
			value:1.25
		},
		{
			name:"150%",
			value:1.50
		},
		{
			name:"175%",
			value:1.75
		},
		{
			name:"200%",
			value:2
		},
		{
			name:"225%",
			value:2.25
		},
		{
			name:"250%",
			value:2.50
		},
		{
			name:"275%",
			value:2.75
		},
		{
			name:"300%",
			value:3
		}
	];
	
	public zoomMovementPixelIncrement = 100;
	
	public zoomApplied = false;
	
	
	// @ngInject
	constructor(
		public $timeout : ng.ITimeoutService,
		public ModalService, 
		public observerService : ObserverService
	){}
	
	public $onInit = () => {
		
		this.speed = this.speedOptions[2];//15 seconds default
		
		if(this.image != null){
			this.speed = {
				value: 0
			};
			
			this.fade = false; 
		}
		
		this.zoomValue = this.zoomOptions[3];//100% default
		
		//set hideFooter property (in case not injected)
		this.hideFooter = this.hideFooter == true || false;
	}
	
	public $onDestroy = () =>{
		this.destroySlick;
	}
	
	public reinitializeSlick = () =>{
		this.destroySlick();
		this.initializeSlick();
	}
	
	public initializeSlick = () =>{
		this.loading = true;
		
		//HACK force digest otherwise $('.modal-gallery-slider') is undefined even though this is called from the link function
		this.$timeout(()=>{
			
			$('.modal-gallery-slider').on('init', (event, slick) => {
				
				
				//HACK force digest otherwise $('.modal-gallery-slider') is undefined
				this.$timeout(()=>{
					
					if(this.slickInitialized) return;
					
					this.slickInitialized = true;
					
					if(this.contentModuleImage != null && this.contentModuleImage.sortOrder != null){
						
						//reinit hack to get image to display https://stackoverflow.com/questions/48254835/slick-slider-width-0-on-initial-page-load
						$('.modal-gallery-slider').slick('unslick').slick('reinit')
						.slick({
						    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-chevron-left"></i></button>', 
						    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-chevron-right"></i></button>',
							infinite: true,
							autoplay: false,
							autoplaySpeed: this.speed.value,
							pauseOnFocus: false,
							pauseOnHover: false,
							fade: this.fade,
							speed: 300,
							lazyLoad: 'ondemand'
						})
						.slick('slickGoTo', this.contentModuleImage.sortOrder - 1);
						
					} else if(this.image != null){
						
						//reinit hack to get image to display https://stackoverflow.com/questions/48254835/slick-slider-width-0-on-initial-page-load
						$('.modal-gallery-slider').slick('unslick').slick('reinit')
						.slick({	
						    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-chevron-left"></i></button>', 
						    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-chevron-right"></i></button>',
							infinite: true,
							autoplay: false,
							autoplaySpeed: this.speed.value,
							pauseOnFocus: false,
							pauseOnHover: false,
							fade: this.fade,
							speed: 300,
							lazyLoad: 'ondemand'
						})
						.slick('slickGoTo', 0);
						
					} else {
						//reinit hack to get image to display https://stackoverflow.com/questions/48254835/slick-slider-width-0-on-initial-page-load
						$('.modal-gallery-slider').slick('unslick').slick('reinit')
						.slick({	
						    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-chevron-left"></i></button>', 
						    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-chevron-right"></i></button>',
							infinite: true,
							autoplay: true,
							autoplaySpeed: this.speed.value,
							pauseOnFocus: false,
							pauseOnHover: false,
							fade: this.fade,
							speed: 300,
							lazyLoad: 'ondemand'
						})
						.slick('slickGoTo', this.goTo || 0);
						
						this.playing = true;
					}
					
					$('.modal-gallery-slider').on('beforeChange', (event, slick, currentSlide)=>{
						console.log('beforeChange', event, slick, currentSlide);
						//reset zoom to zero on change
						this.resetZoom();

					});
					
					this.loading = false;
				});
			});

			$('.modal-gallery-slider').slick({
				prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="fas fa-chevron-left"></i></button>',
				nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="fas fa-chevron-right"></i></button>',
				infinite: true,
				autoplay: true,
				autoplaySpeed: this.speed.value,
				pauseOnFocus: false,
				pauseOnHover: false,
				fade: this.fade,
				speed: this.transitionSpeed,
				lazyLoad: 'ondemand',
			});
		});
	}
	// meanings behind these bools is backwards to the name.
	// when hide... === true, then it's showing
	public hideCreditLineFor=(slideShowType)=>{
		switch (slideShowType) {
			case 'image':
				this.hideImageCreditLine = false;
				break;
			case 'imageNote':
				this.hideImageNote = false;
				break;
			case 'book':
				this.hideBookCreditLine = false;
				break;
			case 'lessonCaption':
				this.hideLessonCaption = false;
				break;
			case 'lesson':
				this.hideLessonCreditLine = false;
				break;
			case 'portfolio':
				this.hidePortfolioCaption = false;
				break;
		}
	}
	
	// meanings behind these bools is backwards to the name.
	// when hide... === true, then it's showing
	public showCreditLineFor=(slideShowType)=>{
		switch (slideShowType) {
			case 'image':
				this.hideImageCreditLine = true;
				break;
			case 'imageNote':
				this.hideImageNote = true;
				break;
			case 'book':
				this.hideBookCreditLine = true;
				break;
			case 'lessonCaption':
				this.hideLessonCaption = true;
				break;
			case 'lesson':
				this.hideLessonCreditLine = true;
				break;
			case 'portfolio':
				this.hidePortfolioCaption = true;
				break;
		}
	}
	
	
	public destroySlick = () =>{
		$('.modal-gallery-slider').slick('unslick');
	}
	
	public resetZoom = () =>{
		
		if(!this.zoomApplied) return;
		
		this.zoomApplied = false;
		
		$('.modal-gallery-slider').slick('slickSetOption', 'accessibility', true);
		
		var activeImage = $(this.imageSelector);
		
		activeImage.css('display', 'none');
		activeImage.css('max-width', '100%');
		activeImage.css('max-height', 'calc(100vh - 96px)');
		activeImage.width(this.originalWidth); 
		activeImage.height(this.originalHeight);
		
		this.originalWidth = null;
		this.originalHeight = null;
		this.currentMarginLeft = 0;
		this.currentMarginTop = 0;
		
		activeImage.css('margin-top', this.currentMarginTop + 'px'); 	
		//activeImage.css('margin-left', this.currentMarginLeft + 'px');
		
		//HACK force digest
		this.$timeout(()=>{
			this.zoomValue = this.zoomOptions[3];
		});
		
		this.$timeout(()=>{
			activeImage.css('display', 'block');
		},this.transitionSpeed)
	}
	
	public togglePlaying = () =>{
		this.playing = !this.playing;
		
		if(this.playing){
			$('.modal-gallery-slider').slick('slickPlay');
		} else {
			$('.modal-gallery-slider').slick('slickPause');
		}
	}
	
	public back = () =>{
		this.resetZoom();
		$('.modal-gallery-slider').slick('slickPrev');
	}
	
	public forward = () =>{
		this.resetZoom();
		$('.modal-gallery-slider').slick('slickNext');
	}
	
	public zoom = (currentZoomLevel=1) =>{
		
		this.zoomApplied = true;
		
		//set accessability to false so arrow keys can be used for navigation
		$('.modal-gallery-slider').slick('slickSetOption', 'accessibility', false);
		$('#GalleryModalCenter').focus();
        
        var viewportHeight = $('.slick-active').height();
        var viewportWidth = $('.slick-active').width();
		
		var activeImage = $(this.imageSelector);

		var width = activeImage.width(); 
		var height = activeImage.height(); 

		if(!this.originalWidth) this.originalWidth = width; 
		if(!this.originalHeight) this.originalHeight = height; 

		width = this.originalWidth * this.zoomValue.value;
		height = this.originalHeight * this.zoomValue.value;
		
		if(width > viewportWidth){
			activeImage.css('max-width', 'none');
		} else {
			activeImage.css('max-width', '100%');
		}
		
		if(height > viewportHeight){
			activeImage.css('max-height', 'none');
		} else {
			activeImage.css('max-height', 'calc(100vh - 96px)');
		}

		activeImage.width(width);
		activeImage.height(height);
	}
	
	public incrementZoom = () =>{
		
		this.zoomApplied = true;
		
		var currentZoom = this.zoomValue.value;
		
		for(var i=0; i<this.zoomOptions.length; i++){
			if(this.zoomValue.value == this.zoomOptions[i].value){
				if(i+1 < this.zoomOptions.length){
					this.zoomValue = this.zoomOptions[i+1];
					break;
				}
			}
		}
		this.zoom(currentZoom);
	}
	
	public decrementZoom = () =>{
		
		this.zoomApplied = true;
		
		var currentZoom = this.zoomValue.value;
		
		for(var i=0; i<this.zoomOptions.length; i++){
			if(this.zoomValue.value == this.zoomOptions[i].value){
				if(i-1 >= 0){
					this.zoomValue = this.zoomOptions[i-1];
					break;
				}
			}
		}
		this.zoom(currentZoom);
	}
	
	public updateBackgroundColor = (color) =>{
		this.backgroundColor = color
	}
	
	public updateSpeed = () =>{
		$('.modal-gallery-slider').slick('slickSetOption', 'autoplaySpeed', this.speed.value, true);
	}
	
	public updateZoom = (event) =>{
		console.log('event', event);
		if(!this.originalHeight || !this.originalWidth) return; 
		
		var activeImage = $(this.imageSelector);
		
		switch(event.originalEvent.keyCode){
			//left
			case 37: 
				if(Math.abs(this.currentMarginLeft + this.zoomMovementPixelIncrement) < (activeImage.width() / 1.25)){
					this.currentMarginLeft += this.zoomMovementPixelIncrement;
				}
				break; 
				
			//up
			case 38: 
				if(Math.abs(this.currentMarginTop + this.zoomMovementPixelIncrement) < (activeImage.height() / 1.25)){
					this.currentMarginTop += this.zoomMovementPixelIncrement;
				}
				break; 

			//right
			case 39: 
				if(Math.abs(this.currentMarginLeft - this.zoomMovementPixelIncrement) < (activeImage.width() / 1.25)){
					this.currentMarginLeft -= this.zoomMovementPixelIncrement;
				}
				break; 

			//down
			case 40: 
				if(Math.abs(this.currentMarginTop - this.zoomMovementPixelIncrement) < (activeImage.height() / 1.25)){
					this.currentMarginTop -= this.zoomMovementPixelIncrement;
				}
				break; 
		}

		activeImage.css('margin-top', this.currentMarginTop + 'px'); 	
		activeImage.css('margin-left', this.currentMarginLeft + 'px');
	}
	
	public close = () =>{
		this.destroySlick();
		this.ModalService.closeModals();
	}
}

class ImageGallerySlideshowModal {
	
	public restrict: string = 'EA';
	public scope: boolean = true;
	
	public bindToController: any = {
		contentModule : '=',
		contentModuleImage : '=?',
		image: '=?',
		images : '=?',
		goTo: '=?',
		hideFooter: '=?',
		hideCraditLine:'=?',
		hideImageNote:"=?"
	};

	public controller = ImageGallerySlideshowModalController;
	public controllerAs = 'imageGallerySlideshowModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/image-gallery-slideshow-modal.html';

	public static Factory() {
		var directive = ($timeout) => new this($timeout);
		directive.$inject = ['$timeout'];
		return directive;
	}
	
	//@ngInject
    constructor(private $timeout){
    }
	
	public link:ng.IDirectiveLinkFn = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs:ng.IAttributes) =>{
		scope.imageGallerySlideshowModal.initializeSlick();
    }
}

export { ImageGallerySlideshowModal };
